import { render, staticRenderFns } from "./copyDrawer.vue?vue&type=template&id=bc72c2f2&scoped=true&"
import script from "./copyDrawer.vue?vue&type=script&lang=js&"
export * from "./copyDrawer.vue?vue&type=script&lang=js&"
import style0 from "./copyDrawer.vue?vue&type=style&index=0&id=bc72c2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc72c2f2",
  null
  
)

export default component.exports